export const en = {
  'app.name': 'COREX',
  'app.tagline': 'Shipping Management System',
  'common.search': 'Search',
  'common.searchPlaceholder': 'Search…',
  'common.filters': 'Filters',
  'common.clear': 'Clear',
  'common.apply': 'Apply',
  'common.reset': 'Reset',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.confirm': 'Confirm',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.view': 'View',
  'common.details': 'Details',
  'common.actions': 'Actions',
  'common.export': 'Export',
  'common.exportExcel': 'Export to Excel',
  'common.print': 'Print',
  'common.refresh': 'Refresh',
  'common.retry': 'Try again',
  'common.loading': 'Loading…',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.all': 'All',
  'common.none': 'None',
  'common.from': 'From',
  'common.to': 'To',
  'common.date': 'Date',
  'common.status': 'Status',
  'common.notes': 'Notes',
  'common.total': 'Total',
  'common.selected': '{count} selected',
  'common.rows': '{count} rows',
  'common.page': 'Page {page}',
  'common.of': 'of {total}',
  'common.perPage': 'Per page',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.required': 'Required',
  'common.optional': 'Optional',
  'common.post': 'Post',
  'common.unpost': 'Unpost',
  'common.posted': 'Posted',
  'common.draft': 'Draft',
  'common.back': 'Back',
  'common.new': 'New',
  'common.open': 'Open',
  'common.today': 'Today',
  'common.last7': 'Last 7 days',
  'common.last30': 'Last 30 days',
  'common.last90': 'Last 3 months',
  'common.thisMonth': 'This month',
  'empty.title': 'Nothing here yet',
  'empty.filtered': 'No results match your filters',
  'empty.filteredHint': 'Try widening the date range or clearing filters.',
  'error.title': 'Something went wrong',
  'error.forbidden': 'You don’t have access to this',
  'error.forbiddenHint': 'Ask an administrator to grant the permission “{permission}”.',
  'error.offline': 'You are offline',
  'error.offlineHint': 'Changes can’t be sent until the connection is back.',
  'error.network': 'Can’t reach the server',
  'error.notFound': 'Page not found',
  'error.requestId': 'Reference: {id}',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in…',
  'auth.signOut': 'Sign out',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.welcome': 'Welcome back',
  'auth.subtitle': 'Sign in with your Dispatch account to continue.',
  'auth.sessionEnded': 'Your session ended. Please sign in again.',
  'auth.evicted': 'You were signed out because this account signed in elsewhere.',
  'auth.noPermissions': 'Your account has no access assigned yet',
  'auth.noPermissionsHint': 'An administrator needs to assign a role to “{user}” (Dispatch role {role}).',
  'auth.changePassword': 'Change password',
  'auth.currentPassword': 'Current password',
  'auth.newPassword': 'New password',
  'auth.passwordChanged': 'Password changed',
  'shell.toggleSidebar': 'Toggle sidebar',
  'shell.searchNav': 'Search pages…',
  'shell.commandHint': 'Jump to a page, an AWB or a mobile number',
  'shell.noNavResults': 'No pages match',
  'shell.theme': 'Theme',
  'shell.themeLight': 'Light',
  'shell.themeDark': 'Dark',
  'shell.themeSystem': 'System',
  'shell.language': 'Language',
  'shell.density': 'Density',
  'shell.densityComfortable': 'Comfortable',
  'shell.densityCompact': 'Compact',
  'shell.errorSoundOn': 'Turn the alert sound on',
  'shell.errorSoundOff': 'Turn the alert sound off',
  'shell.branch': 'Branch',
  'shell.switchBranch': 'Switch branch',
  'shell.home': 'Home',
  'shell.offlineBanner': 'Offline — showing cached data where available.',
  'shell.updateAvailable': 'A new version is available',
  'shell.reload': 'Reload',
  'shell.installApp': 'Install app',
  'gap.title': 'Waiting on backend support',
  'gap.body': 'This screen is part of the operating system plan, but the current Dispatch API has no endpoint for it. It will be enabled once the backend below exists — no placeholder data is shown.',
  'gap.required': 'Required backend / API',
  'gap.related': 'Related live screens',
  'gap.reference': 'Gap reference',
  'table.columns': 'Columns',
  'awb.scanPlaceholder': 'Scan or paste AWBs (one per line, or comma / space separated)',
  'awb.count': '{count} AWBs',
  'awb.invalid': '{count} invalid',
  'awb.duplicates': '{count} duplicates removed',
} as const

export type MessageKey = keyof typeof en
